import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

export const OrganizationFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <GenericFilterDropdown
        filterParam={FilterParam.ORGANIZATION}
        filterName={FilterName.ORGANIZATION}
        valueKey="organizations"
        isNested={isNested}
      />
    )
  },
)
